import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonStringToArray'
})
export class JsonStringToArrayPipe implements PipeTransform {

  transform(value: string): any[]|undefined {
    if (value) {
      value = value.trim();
      if(value.length > 1){
        if(value[1]==','){
          value = "["+value.slice(2);
        }
      }
      let data = (JSON.parse(value).sort((a: { color: { toLowerCase: () => number; }; }, b: { color: { toLowerCase: () => number; }; }) => a.color.toLowerCase() > b.color.toLowerCase() ? 1 : -1));
      const grouped = data.reduce((res: { [x: string]: any[]; }, curr: { color: string | number; name: string; }) => {
        res[curr.color] = res[curr.color] || [];
        if (curr.name && curr.name != "")
          res[curr.color].push(curr.name);
        return res;
      }, {});
      const entries = Object.entries(grouped);
      return (entries);
    }

  }


}
